import { View } from "react-native";
import {
  MaxesView,
  resolveTheme,
  useCatalogItems,
  useMaxesData,
} from "@jackedlogs/ui";
import { apiFetch } from "./api";
import { confirmViaWindow } from "./confirm";
import { writeMax } from "./writeMax";
import { useThemePalette } from "./theme";

// THE Maxes surface on web-rnw — the SAME shared MaxesView mobile's
// Settings → Maxes screen mounts (search + list of P1RM-capable exercises
// + the edit sheet → PUT/DELETE). Web seams: the catalog comes from the
// shared useCatalogItems (no offline cache injected → straight to network),
// the live MAX map from useMaxesData (mobile wraps the same hook in a
// Context for its post-save bump pill; web calls it directly), and the
// destructive-clear confirm via the host-wide web seam (./confirm — RN Alert is
// a no-op on web), shared with Measurements and the coach target editor rather
// than re-implemented here. No native chrome — AppShell's tab supplies the title.

export function MaxesScreen() {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const catalog = useCatalogItems({ apiFetch });
  const { maxes, forceRefresh } = useMaxesData({ apiFetch });

  return (
    <View style={{ flex: 1, backgroundColor: theme.palette.bg }}>
      <MaxesView
        theme={theme}
        catalog={catalog.raw}
        catalogError={null}
        maxes={maxes}
        writeMax={writeMax}
        forceRefresh={forceRefresh}
        confirm={confirmViaWindow}
      />
    </View>
  );
}
